import IsServeMode from "./IsServeMode";

export default function GetUrlPrefix() {
    if(IsServeMode()) {
        return "https://localhost:7050/";
    }

    return "/";
}